export const Members = {
  ATTORNEY: { text: 'Attorney', value: 'attorney' },
  CASE_MANAGER: { text: 'Case Manager', value: 'case manager' }
}

export const MemberOptions = [
  Members.ATTORNEY,
  Members.CASE_MANAGER
]
